/**
 * Trails — shared data & renderer
 * Used by: main-404.liquid, main-search.liquid
 *
 * Usage:
 *   window.initTrails('miy-trail-grid', 'miy-trail-reload');
 */
(function() {
  var trails = [
    {
      name: 'Pacific Crest Trail',
      url: 'https://www.pcta.org/',
      country: 'USA',
      region: 'usa',
      distance: '4,265 km',
      distanceNum: 4265,
      days: '4\u301C6\u30F6\u6708',
      daysNum: 150,
      elevation: '149,000 m+',
      desc: '\u30E1\u30AD\u30B7\u30B3\u56FD\u5883\u304B\u3089\u30AB\u30CA\u30C0\u56FD\u5883\u3078\u3002\u7802\u6F20\u3001\u30B7\u30A8\u30E9\u30CD\u30D0\u30C0\u306E\u96EA\u5C71\u3001\u30AB\u30B9\u30B1\u30FC\u30C9\u5C71\u8108\u306E\u706B\u5C71\u5E2F\u3092\u8CAB\u304F\u3001\u30A2\u30E1\u30EA\u30AB\u897F\u6D77\u5CB8\u3092\u7E26\u65AD\u3059\u308B\u30ED\u30F3\u30B0\u30C8\u30EC\u30A4\u30EB\u3002',
      profile: 'M0,35 5,30 15,18 25,28 35,12 45,22 55,8 65,15 75,20 80,25 90,18 100,10 110,20 120,15 130,22 140,28 150,20 160,14 170,22 180,18 190,25 200,30'
    },
    {
      name: 'John Muir Trail',
      url: 'https://www.pcta.org/discover-the-trail/john-muir-trail/',
      country: 'USA',
      region: 'usa',
      distance: '340 km',
      distanceNum: 340,
      days: '2\u301C3\u9031\u9593',
      daysNum: 21,
      elevation: '14,000 m+',
      desc: '\u30E8\u30BB\u30DF\u30C6\u304B\u3089\u30DE\u30A6\u30F3\u30C8\u30FB\u30DB\u30A4\u30C3\u30C8\u30CB\u30FC\u3078\u3002\u30B7\u30A8\u30E9\u30CD\u30D0\u30C0\u306E\u6838\u5FC3\u90E8\u3092\u6B69\u304F\u3001\u30A2\u30E1\u30EA\u30AB\u3067\u6700\u3082\u7F8E\u3057\u3044\u3068\u79F0\u3055\u308C\u308B\u30C8\u30EC\u30A4\u30EB\u3002',
      profile: 'M0,32 10,25 20,15 30,20 40,10 50,18 60,8 70,14 80,5 90,12 100,8 110,15 120,10 130,18 140,12 150,20 160,8 170,15 180,10 190,5 200,15'
    },
    {
      name: '\u718A\u91CE\u53E4\u9053 \u4E2D\u8FBA\u8DEF',
      url: 'https://www.tb-kumano.jp/kumano-kodo/nakahechi/',
      country: 'Japan',
      region: 'japan',
      distance: '38 km',
      distanceNum: 38,
      days: '2\u301C3\u65E5',
      daysNum: 3,
      elevation: '2,400 m+',
      desc: '\u7D00\u4F0A\u534A\u5CF6\u306E\u5C71\u6DF1\u304F\u306B\u7D9A\u304F\u5DE1\u793C\u306E\u9053\u3002\u4E16\u754C\u907A\u7523\u306B\u767B\u9332\u3055\u308C\u305F\u77F3\u7573\u3068\u6749\u6797\u306E\u4E2D\u3092\u3001\u5343\u5E74\u306E\u6B74\u53F2\u3068\u5171\u306B\u6B69\u304F\u3002',
      profile: 'M0,30 15,15 30,25 45,10 60,28 75,18 90,12 105,22 120,14 140,20 160,10 180,25 200,20'
    },
    {
      name: 'Tour du Mont Blanc',
      url: 'https://www.autourdumontblanc.com/',
      country: 'France / Italy / Switzerland',
      region: 'world',
      distance: '170 km',
      distanceNum: 170,
      days: '7\u301C11\u65E5',
      daysNum: 9,
      elevation: '10,000 m+',
      desc: '\u30E8\u30FC\u30ED\u30C3\u30D1\u6700\u9AD8\u5CF0\u30E2\u30F3\u30D6\u30E9\u30F3\u306E\u5468\u308A\u30923\u30AB\u56FD\u306B\u307E\u305F\u304C\u3063\u3066\u4E00\u5468\u3002\u6C37\u6CB3\u3001\u82B1\u7551\u3001\u4F1D\u7D71\u7684\u306A\u5C71\u5C0F\u5C4B\u304C\u5F85\u3064\u30E8\u30FC\u30ED\u30C3\u30D1\u3092\u4EE3\u8868\u3059\u308B\u30C8\u30EC\u30C3\u30AF\u3002',
      profile: 'M0,25 15,10 30,28 45,8 60,22 75,12 90,30 105,10 120,25 140,8 160,20 180,12 200,25'
    },
    {
      name: '\u4FE1\u8D8A\u30C8\u30EC\u30A4\u30EB',
      url: 'https://www.s-trail.net/',
      country: 'Japan',
      region: 'japan',
      distance: '110 km',
      distanceNum: 110,
      days: '6\u301C8\u65E5',
      daysNum: 7,
      elevation: '4,700 m+',
      desc: '\u9577\u91CE\u3068\u65B0\u6F5F\u306E\u770C\u5883\u3001\u95A2\u7530\u5C71\u8108\u306E\u7A1C\u7DDA\u3092\u6B69\u304F\u91CC\u5C71\u30ED\u30F3\u30B0\u30C8\u30EC\u30A4\u30EB\u3002\u30D6\u30CA\u306E\u539F\u751F\u6797\u3068\u8C4A\u304B\u306A\u7A4D\u96EA\u304C\u80B2\u3080\u3001\u65E5\u672C\u306E\u539F\u98A8\u666F\u3002',
      profile: 'M0,28 15,18 30,12 45,20 60,14 75,22 90,16 105,10 120,18 140,14 160,20 180,16 200,24'
    },
    {
      name: 'GR20',
      url: 'https://www.gr-infos.com/en/gr20.htm',
      country: 'France (Corsica)',
      region: 'world',
      distance: '180 km',
      distanceNum: 180,
      days: '12\u301C16\u65E5',
      daysNum: 14,
      elevation: '12,500 m+',
      desc: '\u30B3\u30EB\u30B7\u30AB\u5CF6\u306E\u810A\u6881\u5C71\u8108\u3092\u7E26\u65AD\u3059\u308B\u30E8\u30FC\u30ED\u30C3\u30D1\u6700\u96E3\u95A2\u306E\u30ED\u30F3\u30B0\u30C8\u30EC\u30A4\u30EB\u3002\u5CA9\u7A1C\u5E2F\u306E\u9023\u7D9A\u3068\u5730\u4E2D\u6D77\u306E\u7D76\u666F\u304C\u540C\u5C45\u3059\u308B\u3002',
      profile: 'M0,30 10,12 20,28 30,5 40,22 50,8 60,25 70,10 80,30 90,8 100,20 110,5 120,18 140,10 160,25 180,15 200,28'
    },
    {
      name: 'Te Araroa',
      url: 'https://www.teararoa.org.nz/',
      country: 'New Zealand',
      region: 'world',
      distance: '3,000 km',
      distanceNum: 3000,
      days: '4\u301C6\u30F6\u6708',
      daysNum: 150,
      elevation: '80,000 m+',
      desc: '\u30CB\u30E5\u30FC\u30B8\u30FC\u30E9\u30F3\u30C9\u3092\u5317\u304B\u3089\u5357\u3078\u5168\u95773,000km\u3002\u706B\u5C71\u3001\u71B1\u5E2F\u96E8\u6797\u3001\u6C37\u6CB3\u3001\u30D5\u30A3\u30E8\u30EB\u30C9\u307E\u3067\u3001\u4E00\u3064\u306E\u56FD\u3068\u306F\u601D\u3048\u306A\u3044\u591A\u69D8\u306A\u666F\u89B3\u3002',
      profile: 'M0,20 10,25 20,15 30,28 40,22 50,30 60,20 70,12 80,25 90,18 100,8 110,22 120,15 140,5 160,18 180,12 200,25'
    },
    {
      name: 'Appalachian Trail',
      url: 'https://appalachiantrail.org/',
      country: 'USA',
      region: 'usa',
      distance: '3,524 km',
      distanceNum: 3524,
      days: '5\u301C7\u30F6\u6708',
      daysNum: 180,
      elevation: '157,000 m+',
      desc: '\u30B8\u30E7\u30FC\u30B8\u30A2\u304B\u3089\u30E1\u30A4\u30F3\u3078\u3001\u30A2\u30E1\u30EA\u30AB\u6771\u90E8\u306E\u68EE\u3092\u6B69\u304F\u4E16\u754C\u3067\u6700\u3082\u6709\u540D\u306A\u30ED\u30F3\u30B0\u30C8\u30EC\u30A4\u30EB\u3002\u30B9\u30EB\u30FC\u30CF\u30A4\u30AB\u30FC\u6587\u5316\u306E\u539F\u70B9\u3002',
      profile: 'M0,22 10,15 20,20 30,12 40,18 50,25 60,15 70,20 80,28 90,18 100,22 110,14 120,20 140,25 160,15 180,20 200,22'
    },
    {
      name: '\u307F\u3061\u306E\u304F\u6F6E\u98A8\u30C8\u30EC\u30A4\u30EB',
      url: 'https://m-tc.org/',
      country: 'Japan',
      region: 'japan',
      distance: '1,025 km',
      distanceNum: 1025,
      days: '1\u301C2\u30F6\u6708',
      daysNum: 60,
      elevation: '20,000 m+',
      desc: '\u9752\u68EE\u30FB\u516B\u6238\u304B\u3089\u798F\u5CF6\u30FB\u76F8\u99AC\u307E\u3067\u3001\u4E09\u9678\u6D77\u5CB8\u6CBF\u3044\u3092\u6B69\u304F\u65E5\u672C\u6700\u9577\u306E\u30ED\u30F3\u30B0\u30C8\u30EC\u30A4\u30EB\u3002\u6771\u65E5\u672C\u5927\u9707\u707D\u304B\u3089\u306E\u5FA9\u8208\u306E\u9053\u3002',
      profile: 'M0,25 10,20 20,28 30,22 40,18 50,25 60,30 70,22 80,16 90,22 100,28 110,20 120,25 140,18 160,28 180,22 200,25'
    },
    {
      name: 'Annapurna Circuit',
      url: 'https://ntb.gov.np/annapurnaregion',
      country: 'Nepal',
      region: 'world',
      distance: '230 km',
      distanceNum: 230,
      days: '12\u301C21\u65E5',
      daysNum: 17,
      elevation: '11,000 m+',
      desc: '\u30A2\u30F3\u30CA\u30D7\u30EB\u30CA\u5C71\u7FA4\u3092\u4E00\u5468\u3059\u308B\u30CD\u30D1\u30FC\u30EB\u306E\u4EE3\u8868\u7684\u30C8\u30EC\u30C3\u30AF\u3002\u6700\u9AD8\u5230\u9054\u70B9\u306E\u30C8\u30ED\u30F3\u30E9\u5CE0\u306F\u6A19\u9AD85,416m\u3002\u30D2\u30DE\u30E9\u30E4\u306E\u5727\u5012\u7684\u30B9\u30B1\u30FC\u30EB\u3002',
      profile: 'M0,35 10,30 20,25 30,20 40,15 50,12 60,8 70,5 80,3 90,5 100,10 110,15 120,20 140,25 160,30 180,32 200,35'
    },
    {
      name: '\u9AD8\u5CF6\u30C8\u30EC\u30A4\u30EB',
      url: 'https://takashima-trail.jp/',
      country: 'Japan',
      region: 'japan',
      distance: '80 km',
      distanceNum: 80,
      days: '5\u301C6\u65E5',
      daysNum: 6,
      elevation: '8,500 m+',
      desc: '\u7435\u7436\u6E56\u306E\u897F\u3001\u9AD8\u5CF6\u5E02\u306E\u4E2D\u592E\u5206\u6C34\u5DBA\u3092\u6B69\u304F\u3002\u65E5\u672C\u6D77\u3068\u592A\u5E73\u6D0B\u306B\u5206\u304B\u308C\u308B\u6C34\u306E\u5206\u5C90\u70B9\u3092\u8FBF\u308B\u3001\u9759\u304B\u306A\u7A1C\u7DDA\u306E\u30C8\u30EC\u30A4\u30EB\u3002',
      profile: 'M0,28 15,15 30,22 45,10 60,18 75,12 90,20 105,14 120,22 140,16 160,12 180,20 200,25'
    },
    {
      name: 'Continental Divide Trail',
      url: 'https://cdtcoalition.org/',
      country: 'USA',
      region: 'usa',
      distance: '4,988 km',
      distanceNum: 4988,
      days: '5\u301C6\u30F6\u6708',
      daysNum: 180,
      elevation: '139,000 m+',
      desc: '\u30E1\u30AD\u30B7\u30B3\u304B\u3089\u30AB\u30CA\u30C0\u3078\u3001\u30ED\u30C3\u30AD\u30FC\u5C71\u8108\u306E\u5927\u9678\u5206\u6C34\u5DBA\u3092\u8FBF\u308B\u3002\u6700\u3082\u8352\u6DBC\u3067\u6700\u3082\u30EF\u30A4\u30EB\u30C9\u306A\u3001\u30A2\u30E1\u30EA\u30AB\u4E09\u5927\u30C8\u30EC\u30A4\u30EB\u306E\u6700\u96E3\u95A2\u3002',
      profile: 'M0,28 10,18 20,10 30,22 40,8 50,15 60,5 70,18 80,12 90,25 100,8 110,15 120,5 140,18 160,10 180,22 200,28'
    },
    {
      name: 'Camino de Santiago',
      url: 'https://www.caminodesantiago.gal/',
      country: 'Spain',
      region: 'world',
      distance: '800 km',
      distanceNum: 800,
      days: '4\u301C5\u9031\u9593',
      daysNum: 35,
      elevation: '12,600 m+',
      desc: '\u30D5\u30E9\u30F3\u30B9\u3068\u306E\u56FD\u5883\u304B\u3089\u30B5\u30F3\u30C6\u30A3\u30A2\u30B4\u30FB\u30C7\u30FB\u30B3\u30F3\u30DD\u30B9\u30C6\u30FC\u30E9\u3078\u3002\u5343\u5E74\u4EE5\u4E0A\u306E\u6B74\u53F2\u3092\u6301\u3064\u5DE1\u793C\u8DEF\u3002\u9EA6\u7551\u3001\u30D6\u30C9\u30A6\u7551\u3001\u4E2D\u4E16\u306E\u753A\u3092\u7E4B\u3050\u7948\u308A\u306E\u9053\u3002',
      profile: 'M0,20 15,15 30,22 45,18 60,12 75,20 90,16 105,22 120,14 140,18 160,22 180,16 200,20'
    },
    {
      name: 'Kungsleden',
      url: 'https://www.swedishtouristassociation.com/areas/kungsleden/',
      country: 'Sweden',
      region: 'world',
      distance: '440 km',
      distanceNum: 440,
      days: '2\u301C4\u9031\u9593',
      daysNum: 21,
      elevation: '9,200 m+',
      desc: '\u30B9\u30A6\u30A7\u30FC\u30C7\u30F3\u5317\u90E8\u30E9\u30C3\u30D7\u30E9\u30F3\u30C9\u3092\u8CAB\u304F\u300C\u738B\u69D8\u306E\u6563\u6B69\u9053\u300D\u3002\u767D\u591C\u306E\u590F\u3001\u6C37\u6CB3\u304C\u524A\u3063\u305F\u8C37\u3001\u30B5\u30FC\u30DF\u306E\u4EBA\u3005\u306E\u66AE\u3089\u3057\u304C\u606F\u3065\u304F\u5317\u6975\u570F\u30C8\u30EC\u30A4\u30EB\u3002',
      profile: 'M0,22 15,14 30,18 45,10 60,16 75,20 90,12 105,18 120,8 140,14 160,20 180,16 200,22'
    },
    {
      name: 'Laugavegur Trail',
      url: 'https://www.fi.is/en/hiking-trails/trails/view/laugavegur',
      country: 'Iceland',
      region: 'world',
      distance: '55 km',
      distanceNum: 55,
      days: '2\u301C4\u65E5',
      daysNum: 3,
      elevation: '1,450 m+',
      desc: '\u30E9\u30F3\u30C9\u30DE\u30F3\u30CA\u30ED\u30A4\u30AC\u30EB\u304B\u3089\u30BD\u30EB\u30B9\u30E2\u30EB\u30AF\u3078\u3002\u6975\u5F69\u8272\u306E\u6D41\u7D0B\u5CA9\u5C71\u3001\u564C\u6C17\u5B54\u3001\u9ED2\u66DC\u77F3\u306E\u7802\u6F20\u3001\u6C37\u6CB3\u306E\u6E21\u6E09\u3002\u5730\u7403\u306E\u5185\u5074\u3092\u8986\u304F\u3088\u3046\u306A\u7570\u4E16\u754C\u30C8\u30EC\u30A4\u30EB\u3002',
      profile: 'M0,18 15,10 30,20 45,8 60,25 75,15 90,10 105,20 120,12 140,22 160,15 180,10 200,18'
    },
    {
      name: 'Overland Track',
      url: 'https://parks.tas.gov.au/explore-our-parks/cradle-mountain/overland-track',
      country: 'Australia',
      region: 'world',
      distance: '65 km',
      distanceNum: 65,
      days: '5\u301C6\u65E5',
      daysNum: 6,
      elevation: '2,600 m+',
      desc: '\u30BF\u30B9\u30DE\u30CB\u30A2\u539F\u751F\u5730\u57DF\u3092\u8CAB\u304F\u5357\u534A\u7403\u3092\u4EE3\u8868\u3059\u308B\u30C8\u30EC\u30A4\u30EB\u3002\u53E4\u4EE3\u304B\u3089\u306E\u30B4\u30F3\u30C9\u30EF\u30CA\u690D\u7269\u3001\u93E1\u306E\u3088\u3046\u306A\u6E56\u3001\u82D4\u3080\u3057\u305F\u6E29\u5E2F\u96E8\u6797\u306E\u4E16\u754C\u3002',
      profile: 'M0,25 15,12 30,20 45,8 60,18 75,14 90,22 105,10 120,16 140,12 160,20 180,18 200,25'
    },
    {
      name: 'Torres del Paine Circuit',
      url: 'https://pasesparques.cl/',
      country: 'Chile',
      region: 'world',
      distance: '130 km',
      distanceNum: 130,
      days: '7\u301C9\u65E5',
      daysNum: 8,
      elevation: '5,000 m+',
      desc: '\u30D1\u30BF\u30B4\u30CB\u30A2\u306E\u8C61\u5FB4\u3001\u30C8\u30FC\u30EC\u30B9\u30FB\u30C7\u30EB\u30FB\u30D1\u30A4\u30CD\u5C71\u7FA4\u3092\u4E00\u5468\u3002\u5DE8\u5927\u306A\u82B1\u5D17\u5CA9\u306E\u5854\u3001\u6C37\u6CB3\u3001\u66B4\u98A8\u3002\u5357\u7C73\u306E\u6700\u679C\u3066\u306B\u5E83\u304C\u308B\u58EE\u7D76\u306A\u7F8E\u3057\u3055\u3002',
      profile: 'M0,28 10,18 20,10 30,22 40,5 50,18 60,12 70,25 80,8 90,20 100,14 110,22 120,10 140,20 160,15 180,25 200,28'
    },
    {
      name: 'Lycian Way',
      url: 'https://cultureroutesinturkey.com/the-lycian-way/',
      country: 'Turkey',
      region: 'world',
      distance: '540 km',
      distanceNum: 540,
      days: '4\u301C5\u9031\u9593',
      daysNum: 35,
      elevation: '18,000 m+',
      desc: '\u30C8\u30EB\u30B3\u5357\u897F\u90E8\u306E\u5730\u4E2D\u6D77\u6CBF\u5CB8\u3092\u6B69\u304F\u3002\u30EA\u30AD\u30A2\u6587\u660E\u306E\u53E4\u4EE3\u907A\u8DE1\u3001\u7D3A\u78A7\u306E\u6D77\u3001\u677E\u6797\u306E\u7A1C\u7DDA\u3002\u6587\u660E\u3068\u81EA\u7136\u304C\u4EA4\u5DEE\u3059\u308B\u3001\u6B74\u53F2\u306E\u30C8\u30EC\u30A4\u30EB\u3002',
      profile: 'M0,30 10,18 20,28 30,10 40,22 50,14 60,28 70,8 80,20 90,12 100,25 110,18 120,28 140,14 160,22 180,10 200,25'
    },
    {
      name: '\u6771\u6D77\u81EA\u7136\u6B69\u9053',
      url: 'http://www.tokai-walk.jp/',
      country: 'Japan',
      region: 'japan',
      distance: '1,697 km',
      distanceNum: 1697,
      days: '40\u301C50\u65E5',
      daysNum: 45,
      elevation: '45,000 m+',
      desc: '\u6771\u4EAC\u30FB\u9AD8\u5C3E\u5C71\u304B\u3089\u5927\u962A\u30FB\u7B95\u9762\u307E\u3067\u3001\u65E5\u672C\u521D\u306E\u9577\u8DDD\u96E2\u81EA\u7136\u6B69\u9053\u3002\u5BCC\u58EB\u5C71\u9E93\u3001\u5357\u30A2\u30EB\u30D7\u30B9\u5C71\u9E93\u3001\u7435\u7436\u6E56\u7554\u3092\u7D4C\u7531\u3057\u300111\u90FD\u5E9C\u770C\u3092\u7E4B\u3050\u58EE\u5927\u306A\u9053\u3002',
      profile: 'M0,25 10,15 20,22 30,10 40,20 50,8 60,18 70,14 80,22 90,12 100,20 110,15 120,22 140,18 160,10 180,20 200,25'
    },
    {
      name: '\u56FD\u6771\u534A\u5CF6\u5CEF\u9053\u30ED\u30F3\u30B0\u30C8\u30EC\u30A4\u30EB',
      url: 'https://kunisakihantou-trail.com/',
      country: 'Japan',
      region: 'japan',
      distance: '135 km',
      distanceNum: 135,
      days: '7\u301C10\u65E5',
      daysNum: 9,
      elevation: '7,200 m+',
      desc: '\u5927\u5206\u770C\u30FB\u56FD\u6771\u534A\u5CF6\u306E\u5CF0\u3005\u3092\u5DE1\u308B\u4FEE\u9A13\u306E\u9053\u3002\u795E\u4ECF\u7FD2\u5408\u306E\u77F3\u4ECF\u7FA4\u3001\u82D4\u3080\u3057\u305F\u78E8\u5D16\u4ECF\u3001\u516D\u90F7\u6E80\u5C71\u306E\u5BFA\u9662\u30021300\u5E74\u306E\u5C71\u5CB3\u4FE1\u4EF0\u304C\u606F\u3065\u304F\u7948\u308A\u306E\u30C8\u30EC\u30A4\u30EB\u3002',
      profile: 'M0,28 10,12 20,25 30,8 40,22 50,15 60,28 70,10 80,20 90,8 100,25 110,14 120,22 140,10 160,20 180,14 200,28'
    },
    {
      name: '\u30C0\u30A4\u30E4\u30E2\u30F3\u30C9\u30C8\u30EC\u30FC\u30EB',
      url: 'https://www.pref.osaka.lg.jp/o120170/minamikawachinm/m_index/r_daitore.html',
      country: 'Japan',
      region: 'japan',
      distance: '45 km',
      distanceNum: 45,
      days: '1\u301C2\u65E5',
      daysNum: 2,
      elevation: '3,500 m+',
      desc: '\u5927\u962A\u3068\u5948\u826F\u306E\u5E9C\u770C\u5883\u3001\u91D1\u525B\u5C71\u5730\u306E\u7A1C\u7DDA\u3092\u8FBF\u308B\u7E26\u8D70\u8DEF\u3002\u4E8C\u4E0A\u5C71\u304B\u3089\u69C7\u5C3E\u5C71\u307E\u3067\u3001\u53E4\u4EE3\u306E\u845B\u57CE\u738B\u671D\u306E\u9762\u5F71\u304C\u6B8B\u308B\u6B74\u53F2\u3068\u5C55\u671B\u306E\u7A1C\u7DDA\u6B69\u304D\u3002',
      profile: 'M0,20 15,10 30,18 45,8 60,14 75,10 90,18 105,12 120,8 140,15 160,10 180,18 200,22'
    },
    {
      name: '\u5C4B\u4E45\u5CF6 \u5BAE\u4E4B\u6D66\u5CB3\u7E26\u8D70\u8DEF',
      url: 'https://www.env.go.jp/park/yakushima/ywhcc/tozan/tozan.html',
      country: 'Japan',
      region: 'japan',
      distance: '25 km',
      distanceNum: 25,
      days: '1\u301C2\u65E5',
      daysNum: 2,
      elevation: '1,900 m+',
      desc: '\u4E5D\u5DDE\u6700\u9AD8\u5CF0\u30FB\u5BAE\u4E4B\u6D66\u5CB3\u3092\u8D8A\u3048\u308B\u6D0B\u4E0A\u30A2\u30EB\u30D7\u30B9\u7E26\u8D70\u3002\u6A39\u9F62\u6570\u5343\u5E74\u306E\u5C4B\u4E45\u6749\u3001\u82B1\u5D17\u5CA9\u306E\u5DE8\u77F3\u7FA4\u3001\u4E9C\u71B1\u5E2F\u304B\u3089\u4E9C\u9AD8\u5C71\u5E2F\u307E\u3067\u51DD\u7E2E\u3055\u308C\u305F\u5782\u76F4\u306E\u81EA\u7136\u3002',
      profile: 'M0,35 10,28 20,18 30,12 40,8 50,5 60,3 70,5 80,8 90,12 100,18 110,25 120,30 140,35 160,32 180,28 200,35'
    },
    {
      name: '\u516D\u7532\u5168\u5C71\u7E26\u8D70\u8DEF',
      url: 'https://www.city.kobe.lg.jp/a41153/kanko/event/rokko/index.html',
      country: 'Japan',
      region: 'japan',
      distance: '56 km',
      distanceNum: 56,
      days: '1\u301C2\u65E5',
      daysNum: 2,
      elevation: '3,000 m+',
      desc: '\u9808\u78E8\u6D66\u516C\u5712\u304B\u3089\u5B9D\u585A\u307E\u3067\u3001\u516D\u7532\u5C71\u7CFB\u3092\u6771\u897F\u306B\u8CAB\u304F\u7E26\u8D70\u8DEF\u3002\u5927\u962A\u6E7E\u306E\u773A\u671B\u3001\u82B1\u5D17\u5CA9\u306E\u5CA9\u7A1C\u3001\u795E\u6238\u306E\u591C\u666F\u3002\u90FD\u5E02\u8FD1\u90CA\u3068\u306F\u601D\u3048\u306A\u3044\u30CF\u30FC\u30C9\u306A\u30C8\u30EC\u30A4\u30EB\u3002',
      profile: 'M0,30 10,18 20,25 30,12 40,20 50,8 60,15 70,10 80,18 90,8 100,14 110,10 120,18 140,12 160,8 180,15 200,28'
    },
    {
      name: '\u56DB\u56FD\u516B\u5341\u516B\u30F6\u6240\u904D\u8DEF\u9053',
      url: 'https://88shikokuhenro.jp/',
      country: 'Japan',
      region: 'japan',
      distance: '1,200 km',
      distanceNum: 1200,
      days: '1\u301C2\u30F6\u6708',
      daysNum: 60,
      elevation: '25,000 m+',
      desc: '\u5F18\u6CD5\u5927\u5E2B\u3086\u304B\u308A\u306E88\u306E\u5BFA\u9662\u3092\u5DE1\u308B\u56DB\u56FD\u4E00\u5468\u306E\u5DE1\u793C\u9053\u30021200\u5E74\u306E\u6B74\u53F2\u3092\u6301\u3064\u7948\u308A\u306E\u65C5\u8DEF\u3002\u304A\u63A5\u5F85\u306E\u6587\u5316\u3068\u3001\u6B69\u304D\u904D\u8DEF\u304C\u51FA\u4F1A\u3046\u56DB\u56FD\u306E\u539F\u98A8\u666F\u3002',
      profile: 'M0,22 10,15 20,25 30,18 40,10 50,20 60,14 70,25 80,12 90,22 100,16 110,28 120,14 140,20 160,12 180,22 200,22'
    },
    {
      name: '\u4E5D\u5DDE\u81EA\u7136\u6B69\u9053',
      url: 'https://kyushu.env.go.jp/naturetrail/index.html',
      country: 'Japan',
      region: 'japan',
      distance: '2,932 km',
      distanceNum: 2932,
      days: '3\u301C5\u30F6\u6708',
      daysNum: 120,
      elevation: '80,000 m+',
      desc: '\u4E5D\u5DDE7\u770C\u3092\u4E00\u5468\u3059\u308B\u65E5\u672C\u6700\u9577\u7D1A\u306E\u81EA\u7136\u6B69\u9053\u3002\u963F\u8607\u306E\u8349\u5343\u91CC\u3001\u304F\u3058\u3085\u3046\u9023\u5C71\u3001\u9727\u5CF6\u306E\u706B\u5C71\u7FA4\u3001\u5C4B\u4E45\u5CF6\u306E\u539F\u751F\u6797\u3002\u706B\u306E\u56FD\u306E\u5927\u5730\u3092\u7E4B\u3050\u30B9\u30B1\u30FC\u30EB\u306E\u9053\u3002',
      profile: 'M0,25 10,12 20,20 30,8 40,18 50,10 60,22 70,5 80,15 90,10 100,22 110,8 120,18 140,12 160,20 180,15 200,25'
    },
    {
      name: '\u30A8\u30D9\u30EC\u30B9\u30C8\u8857\u9053',
      url: 'https://ntb.gov.np/everest-base-camp',
      country: 'Nepal',
      region: 'world',
      distance: '130 km',
      distanceNum: 130,
      days: '12\u301C14\u65E5',
      daysNum: 13,
      elevation: '7,300 m+',
      desc: '\u30EB\u30AF\u30E9\u304B\u3089\u30A8\u30D9\u30EC\u30B9\u30C8\u30D9\u30FC\u30B9\u30AD\u30E3\u30F3\u30D7\uFF085,364m\uFF09\u3092\u76EE\u6307\u3059\u3001\u30D2\u30DE\u30E9\u30E4\u3067\u6700\u3082\u6709\u540D\u306A\u30C8\u30EC\u30C3\u30AD\u30F3\u30B0\u30EB\u30FC\u30C8\u3002\u30AB\u30E9\u30D1\u30BF\u30FC\u30EB\u304B\u3089\u306F\u30A8\u30D9\u30EC\u30B9\u30C8\u306E\u5727\u5DFB\u306E\u773A\u671B\u304C\u5E83\u304C\u308B\u3002',
      profile: 'M0,35 10,32 20,28 30,25 40,22 50,20 60,18 70,22 80,16 90,12 100,8 110,5 120,8 130,12 140,16 150,20 160,25 170,28 180,32 200,35'
    },
    {
      name: '\u30E9\u30F3\u30BF\u30F3\u8C37\u30C8\u30EC\u30C3\u30AF',
      url: 'https://ntb.gov.np/langtang-national-park',
      country: 'Nepal',
      region: 'world',
      distance: '75 km',
      distanceNum: 75,
      days: '7\u301C10\u65E5',
      daysNum: 9,
      elevation: '3,400 m+',
      desc: '\u30AB\u30C8\u30DE\u30F3\u30BA\u304B\u3089\u6700\u3082\u30A2\u30AF\u30BB\u30B9\u3057\u3084\u3059\u3044\u30D2\u30DE\u30E9\u30E4\u30C8\u30EC\u30C3\u30AD\u30F3\u30B0\u30EB\u30FC\u30C8\u306E\u4E00\u3064\u3002\u6C37\u6CB3\u3092\u671B\u3080\u96C4\u5927\u306A\u8C37\u3068\u3001\u30BF\u30DE\u30F3\u65CF\u306E\u6587\u5316\u306B\u89E6\u308C\u308B\u9759\u304B\u306A\u5C71\u65C5\u304C\u9B45\u529B\u3002',
      profile: 'M0,35 15,30 30,25 45,20 60,18 75,15 90,10 105,8 120,10 135,15 150,20 165,25 180,30 200,35'
    },
    {
      name: 'Great Himalaya Trail',
      url: 'https://www.greathimalayatrail.com/',
      country: 'Nepal',
      region: 'world',
      distance: '1,700 km',
      distanceNum: 1700,
      days: '4\u301C5\u30F6\u6708',
      daysNum: 150,
      elevation: '120,000 m+',
      desc: '\u30CD\u30D1\u30FC\u30EB\u3092\u6771\u306E\u30AB\u30F3\u30C1\u30A7\u30F3\u30B8\u30E5\u30F3\u30AC\u304B\u3089\u897F\u306E\u30D5\u30E0\u30E9\u307E\u3067\u6A2A\u65AD\u3059\u308B\u3001\u4E16\u754C\u6700\u9577\u30FB\u6700\u9AD8\u6240\u306E\u30ED\u30F3\u30B0\u30C8\u30EC\u30A4\u30EB\u30025,000m\u3092\u8D85\u3048\u308B\u5CE0\u309220\u4EE5\u4E0A\u8D8A\u3048\u308B\u7A76\u6975\u306E\u30D2\u30DE\u30E9\u30E4\u7E26\u8D70\u8DEF\u3002',
      profile: 'M0,20 10,5 20,30 30,8 40,35 50,3 60,28 70,10 80,32 90,5 100,25 110,8 120,30 130,5 140,28 150,10 160,32 170,8 180,25 200,15'
    },
    {
      name: 'Fish River Canyon Trail',
      url: 'https://www.nwr.com.na/',
      country: 'Namibia',
      region: 'world',
      distance: '85 km',
      distanceNum: 85,
      days: '4\u301C5\u65E5',
      daysNum: 5,
      elevation: '500 m+',
      desc: '\u4E16\u754C\u7B2C2\u306E\u898F\u6A21\u3092\u8A87\u308B\u30CA\u30DF\u30D3\u30A2\u306E\u30D5\u30A3\u30C3\u30B7\u30E5\u30EA\u30D0\u30FC\u30AD\u30E3\u30CB\u30AA\u30F3\u3092\u7E26\u65AD\u3059\u308B\u3001\u30A2\u30D5\u30EA\u30AB\u3092\u4EE3\u8868\u3059\u308B\u30C8\u30EC\u30A4\u30EB\u3002\u6DF1\u3055550m\u306E\u5CE1\u8C37\u306B\u4E0B\u308A\u300115\u5104\u5E74\u306E\u5730\u8CEA\u304C\u523B\u307E\u308C\u305F\u6CB3\u5E8A\u3092\u6B69\u304F\u58EE\u5927\u306A\u8352\u91CE\u306E\u65C5\u3002',
      profile: 'M0,5 10,20 20,30 30,32 40,33 50,33 60,34 70,34 80,35 90,35 100,35 110,34 120,35 140,35 160,36 180,36 200,38'
    },
    {
      name: '\u5927\u96EA\u5C71\u7E26\u8D70\u8DEF\uFF08\u65ED\u5CB3\u301C\u30C8\u30E0\u30E9\u30A6\u30B7\uFF09',
      url: 'https://www.env.go.jp/park/daisetsu/',
      country: 'Japan',
      region: 'japan',
      distance: '55 km',
      distanceNum: 55,
      days: '3\u301C4\u65E5',
      daysNum: 4,
      elevation: '3,500 m+',
      desc: '\u65E5\u672C\u6700\u5927\u306E\u5C71\u5CB3\u9AD8\u539F\u5730\u5E2F\u3092\u6B69\u304F\u7A7A\u4E2D\u56DE\u5ECA\u3002\u30CA\u30AD\u30A6\u30B5\u30AE\u304C\u66AE\u3089\u3059\u30AB\u30E0\u30A4\u30DF\u30F3\u30BF\u30E9\uFF08\u795E\u3005\u306E\u904A\u3076\u5EAD\uFF09\u3092\u3001\u82B1\u3068\u6B8B\u96EA\u306E\u7A1C\u7DDA\u304C\u7E4B\u3050\u3002',
      profile: 'M0,22 10,10 20,18 30,5 40,15 50,8 60,20 70,5 80,12 90,8 100,18 110,10 120,15 140,8 160,12 180,18 200,25'
    },
    {
      name: '\u5341\u52DD\u30ED\u30F3\u30B0\u30C8\u30EC\u30A4\u30EB',
      url: 'http://www.easttokachi-longtrail.com/',
      country: 'Japan',
      region: 'japan',
      distance: '100 km',
      distanceNum: 100,
      days: '3\u301C4\u65E5',
      daysNum: 4,
      elevation: '2,000 m+',
      desc: '\u5341\u52DD\u5E73\u91CE\u306E\u5E83\u5927\u306A\u8FB2\u696D\u666F\u89B3\u3068\u65E5\u9AD8\u5C71\u8108\u306E\u773A\u671B\u3002\u5317\u6D77\u9053\u958B\u62D3\u306E\u8DB3\u8DE1\u3092\u8FBF\u308A\u306A\u304C\u3089\u3001\u5927\u5730\u306E\u606F\u5439\u3092\u611F\u3058\u308B\u5E73\u539F\u6B69\u304D\u3002',
      profile: 'M0,28 10,25 20,22 30,26 40,24 50,20 60,25 70,28 80,22 90,26 100,24 110,28 120,22 140,25 160,28 180,24 200,26'
    },
    {
      name: '\u671D\u65E5\u9023\u5CF0\u7E26\u8D70\u8DEF',
      url: 'https://www.env.go.jp/park/bandai/',
      country: 'Japan',
      region: 'japan',
      distance: '35 km',
      distanceNum: 35,
      days: '2\u301C3\u65E5',
      daysNum: 3,
      elevation: '4,000 m+',
      desc: '\u6771\u5317\u306E\u79D8\u5CF0\u3092\u7E4B\u3050\u91CD\u539A\u306A\u7A1C\u7DDA\u6B69\u304D\u3002\u4EE5\u6771\u5CB3\u304B\u3089\u5927\u671D\u65E5\u5CB3\u3078\u3001\u4EBA\u306E\u5C11\u306A\u3044\u9759\u304B\u306A\u5C71\u57DF\u3067\u539F\u59CB\u7684\u306A\u5C71\u5CB3\u98A8\u666F\u306B\u6D78\u308B\u3002',
      profile: 'M0,30 10,18 20,8 30,15 40,5 50,12 60,8 70,18 80,5 90,10 100,5 110,12 120,8 140,15 160,10 180,18 200,28'
    },
    {
      name: '\u98EF\u8C4A\u9023\u5CF0\u4E3B\u7A1C\u7E26\u8D70\u8DEF',
      url: 'https://www.env.go.jp/park/bandai/',
      country: 'Japan',
      region: 'japan',
      distance: '50 km',
      distanceNum: 50,
      days: '3\u301C5\u65E5',
      daysNum: 4,
      elevation: '5,500 m+',
      desc: '\u5C71\u5F62\u30FB\u65B0\u6F5F\u30FB\u798F\u5CF6\u306E\u770C\u5883\u3092\u8DE8\u3050\u3001\u6771\u5317\u5C48\u6307\u306E\u30ED\u30F3\u30B0\u7E26\u8D70\u3002\u4E07\u5E74\u96EA\u6E13\u3068\u9AD8\u5C71\u690D\u7269\u306E\u7A1C\u7DDA\u306F\u3001\u30A2\u30D7\u30ED\u30FC\u30C1\u306E\u9060\u3055\u304C\u5B88\u308B\u5225\u5929\u5730\u3002',
      profile: 'M0,35 10,22 20,10 30,18 40,5 50,12 60,8 70,5 80,10 90,5 100,8 110,12 120,18 140,10 160,15 180,22 200,32'
    },
    {
      name: '\u3075\u304F\u3057\u307E\u6D5C\u8857\u9053\u30C8\u30EC\u30A4\u30EB',
      url: 'https://fukushima-coastal-trail.jp/',
      country: 'Japan',
      region: 'japan',
      distance: '220 km',
      distanceNum: 220,
      days: '8\u301C12\u65E5',
      daysNum: 10,
      elevation: '3,500 m+',
      desc: '\u798F\u5CF6\u770C\u306E\u592A\u5E73\u6D0B\u6CBF\u5CB8\u3092\u6B69\u304F\u5FA9\u8208\u306E\u30C8\u30EC\u30A4\u30EB\u3002\u76F8\u99AC\u304B\u3089\u52FF\u6765\u307E\u3067\u3001\u6D5C\u901A\u308A\u306E\u6B74\u53F2\u3068\u4ECA\u3092\u81EA\u5206\u306E\u8DB3\u3067\u78BA\u304B\u3081\u308B\u65C5\u8DEF\u3002',
      profile: 'M0,30 10,26 20,30 30,24 40,28 50,22 60,26 70,20 80,28 90,24 100,30 110,22 120,28 140,24 160,26 180,22 200,28'
    },
    {
      name: '\u3050\u3093\u307E\u770C\u5883\u7A1C\u7DDA\u30C8\u30EC\u30A4\u30EB',
      url: 'https://www.gunma-trail.jp/',
      country: 'Japan',
      region: 'japan',
      distance: '100 km',
      distanceNum: 100,
      days: '5\u301C7\u65E5',
      daysNum: 6,
      elevation: '8,000 m+',
      desc: '\u8C37\u5DDD\u5CB3\u304B\u3089\u767D\u7802\u5C71\u3078\u3001\u7FA4\u99AC\u770C\u5883\u306E\u7A1C\u7DDA\u3092\u4E00\u672C\u306B\u7E4B\u3044\u3060\u65B0\u3057\u3044\u30C8\u30EC\u30A4\u30EB\u3002\u4E0A\u8D8A\u56FD\u5883\u306E\u5909\u5316\u306B\u5BCC\u3093\u3060\u5C71\u5CB3\u666F\u89B3\u304C\u7D9A\u304F\u3002',
      profile: 'M0,25 10,10 20,18 30,5 40,14 50,8 60,20 70,10 80,5 90,12 100,8 110,18 120,12 140,5 160,14 180,20 200,25'
    },
    {
      name: '\u5965\u79E9\u7236\u4E3B\u8108\u7E26\u8D70\u8DEF',
      url: 'https://www.env.go.jp/park/chichibu/guide/view.html',
      country: 'Japan',
      region: 'japan',
      distance: '60 km',
      distanceNum: 60,
      days: '3\u301C4\u65E5',
      daysNum: 4,
      elevation: '4,500 m+',
      desc: '\u91D1\u5CF0\u5C71\u304B\u3089\u96F2\u53D6\u5C71\u3078\u3001\u95A2\u6771\u306E\u5C4B\u6839\u3092\u6B69\u304F\u82D4\u3068\u539F\u751F\u6797\u306E\u7E26\u8D70\u8DEF\u3002\u9996\u90FD\u570F\u304B\u3089\u8FD1\u3044\u306E\u306B\u6DF1\u3044\u5C71\u306E\u9759\u3051\u3055\u304C\u3042\u308B\u3002',
      profile: 'M0,20 10,8 20,15 30,10 40,18 50,8 60,12 70,10 80,14 90,10 100,16 110,12 120,18 140,14 160,10 180,16 200,22'
    },
    {
      name: '\u30B9\u30CE\u30FC\u30AB\u30F3\u30C8\u30EA\u30FC\u30C8\u30EC\u30A4\u30EB',
      url: 'https://snowcountrytrail.jp/',
      country: 'Japan',
      region: 'japan',
      distance: '307 km',
      distanceNum: 307,
      days: '12\u301C18\u65E5',
      daysNum: 15,
      elevation: '10,000 m+',
      desc: '\u65B0\u6F5F\u770C\u306E\u8C6A\u96EA\u5730\u5E2F\u3092\u8CAB\u304F\u3001\u30D6\u30CA\u6797\u3068\u68DA\u7530\u306E\u91CC\u5C71\u30ED\u30F3\u30B0\u30C8\u30EC\u30A4\u30EB\u3002\u96EA\u56FD\u306E\u66AE\u3089\u3057\u3068\u81EA\u7136\u304C\u7E54\u308A\u306A\u3059\u98A8\u666F\u306E\u4E2D\u3092\u6B69\u304F\u3002',
      profile: 'M0,22 10,15 20,20 30,12 40,18 50,10 60,22 70,14 80,18 90,12 100,20 110,14 120,22 140,16 160,12 180,18 200,22'
    },
    {
      name: '\u5317\u30A2\u30EB\u30D7\u30B9 \u8868\u9280\u5EA7\u7E26\u8D70\u8DEF',
      url: 'https://www.env.go.jp/park/chubu/',
      country: 'Japan',
      region: 'japan',
      distance: '40 km',
      distanceNum: 40,
      days: '3\u301C4\u65E5',
      daysNum: 4,
      elevation: '4,500 m+',
      desc: '\u71D5\u5CB3\u304B\u3089\u69CD\u30F6\u5CB3\u3078\u3001\u65E5\u672C\u30A2\u30EB\u30D7\u30B9\u306E\u738B\u9053\u7E26\u8D70\u8DEF\u3002\u7A1C\u7DDA\u306B\u51FA\u305F\u77AC\u9593\u304B\u3089\u69CD\u306E\u7A42\u5148\u3092\u6B63\u9762\u306B\u898B\u636E\u3048\u3066\u6B69\u304F\u3001\u9AD8\u63DA\u306E3\u65E5\u9593\u3002',
      profile: 'M0,35 10,20 20,8 30,12 40,5 50,8 60,5 70,10 80,5 90,3 100,8 110,5 120,10 140,5 160,3 180,10 200,30'
    },
    {
      name: '\u5317\u30A2\u30EB\u30D7\u30B9 \u88CF\u9280\u5EA7\u7E26\u8D70\u8DEF',
      url: 'https://www.env.go.jp/park/chubu/',
      country: 'Japan',
      region: 'japan',
      distance: '55 km',
      distanceNum: 55,
      days: '3\u301C4\u65E5',
      daysNum: 4,
      elevation: '5,000 m+',
      desc: '\u70CF\u5E3D\u5B50\u5CB3\u304B\u3089\u91CE\u53E3\u4E94\u90CE\u3001\u9DF2\u7FBD\u3001\u4E09\u4FE3\u84EE\u83EF\u3092\u7D4C\u3066\u69CD\u30F6\u5CB3\u3078\u3002\u8868\u9280\u5EA7\u3088\u308A\u9759\u304B\u306A\u7A1C\u7DDA\u3067\u3001\u5317\u30A2\u30EB\u30D7\u30B9\u306E\u5965\u6DF1\u3055\u3092\u77E5\u308B\u3002',
      profile: 'M0,32 10,18 20,5 30,12 40,8 50,5 60,10 70,5 80,8 90,3 100,10 110,5 120,8 140,3 160,8 180,15 200,30'
    },
    {
      name: '\u5357\u30A2\u30EB\u30D7\u30B9\u5168\u5C71\u7E26\u8D70\u8DEF',
      url: 'https://www.env.go.jp/park/minamialps/',
      country: 'Japan',
      region: 'japan',
      distance: '140 km',
      distanceNum: 140,
      days: '7\u301C10\u65E5',
      daysNum: 9,
      elevation: '15,000 m+',
      desc: '\u7532\u6590\u99D2\u30F6\u5CB3\u304B\u3089\u5149\u5CB3\u307E\u3067\u30013,000m\u7D1A\u306E\u767E\u540D\u5C7110\u5EA7\u3092\u7E4B\u3050\u65E5\u672C\u5C48\u6307\u306E\u30ED\u30F3\u30B0\u7E26\u8D70\u3002\u6DF1\u3044\u68EE\u3068\u9AD8\u3044\u7A1C\u7DDA\u306E\u7E70\u308A\u8FD4\u3057\u3002',
      profile: 'M0,30 10,5 20,25 30,3 40,20 50,5 60,22 70,3 80,18 90,5 100,22 110,8 120,25 130,5 140,20 150,8 160,22 170,5 180,18 200,28'
    },
    {
      name: '\u5869\u306E\u9053\u30C8\u30EC\u30A4\u30EB\uFF08\u5343\u56FD\u8857\u9053\uFF09',
      url: 'http://sionomichi-trail.com/',
      country: 'Japan',
      region: 'japan',
      distance: '120 km',
      distanceNum: 120,
      days: '5\u301C7\u65E5',
      daysNum: 6,
      elevation: '4,000 m+',
      desc: '\u65E5\u672C\u6D77\u306E\u5869\u3092\u4FE1\u5DDE\u3078\u904B\u3093\u3060\u53E4\u9053\u3002\u7CF8\u9B5A\u5DDD\u304B\u3089\u677E\u672C\u307E\u3067\u3001\u5317\u30A2\u30EB\u30D7\u30B9\u306E\u5C71\u9E93\u3092\u7E2B\u3046\u3088\u3046\u306B\u5BBF\u5834\u753A\u3068\u5CE0\u9053\u304C\u7D9A\u304F\u6B74\u53F2\u8857\u9053\u3002',
      profile: 'M0,30 10,22 20,28 30,18 40,25 50,15 60,22 70,18 80,25 90,20 100,28 110,22 120,18 140,22 160,18 180,22 200,28'
    },
    {
      name: '\u4E2D\u592E\u5206\u6C34\u5DBA\u30C8\u30EC\u30A4\u30EB',
      url: 'https://www.c-trail.com/',
      country: 'Japan',
      region: 'japan',
      distance: '38 km',
      distanceNum: 38,
      days: '2\u301C3\u65E5',
      daysNum: 3,
      elevation: '2,500 m+',
      desc: '\u592A\u5E73\u6D0B\u3068\u65E5\u672C\u6D77\u3092\u5206\u3051\u308B\u5206\u6C34\u5DBA\u3092\u6B69\u304F\u3001\u9577\u91CE\u770C\u9727\u30F6\u5CF0\u5468\u8FBA\u306E\u9AD8\u539F\u30C8\u30EC\u30A4\u30EB\u3002\u898B\u6E21\u3059\u9650\u308A\u306E\u8349\u539F\u3068\u82B1\u306E\u7A1C\u7DDA\u3002',
      profile: 'M0,18 10,12 20,15 30,10 40,14 50,10 60,12 70,10 80,14 90,12 100,10 110,14 120,12 140,10 160,14 180,12 200,18'
    },
    {
      name: '\u4EAC\u90FD\u4E00\u5468\u30C8\u30EC\u30A4\u30EB',
      url: 'https://ja.kyoto.travel/tourism/article/trail/',
      country: 'Japan',
      region: 'japan',
      distance: '84 km',
      distanceNum: 84,
      days: '5\u301C6\u65E5',
      daysNum: 6,
      elevation: '4,500 m+',
      desc: '\u4F0F\u898B\u6843\u5C71\u304B\u3089\u6BD4\u53E1\u5C71\u3001\u5927\u539F\u3001\u978D\u99AC\u3001\u5D50\u5C71\u3078\u3002\u5343\u5E74\u306E\u90FD\u3092\u56F2\u3080\u5C71\u3005\u3092\u5DE1\u308A\u3001\u8857\u3068\u5C71\u304C\u96A3\u308A\u5408\u3046\u4EAC\u90FD\u306E\u5730\u5F62\u3092\u4F53\u611F\u3059\u308B\u3002',
      profile: 'M0,28 10,18 20,10 30,22 40,14 50,20 60,10 70,18 80,12 90,22 100,14 110,8 120,18 140,12 160,20 180,14 200,26'
    },
    {
      name: '\u5927\u5CEF\u5965\u99C8\u9053',
      url: 'https://www.sekaiisan-wakayama.jp/know/omine-okugake-michi/',
      country: 'Japan',
      region: 'japan',
      distance: '90 km',
      distanceNum: 90,
      days: '4\u301C6\u65E5',
      daysNum: 5,
      elevation: '8,000 m+',
      desc: '\u5409\u91CE\u304B\u3089\u718A\u91CE\u672C\u5BAE\u3078\u3001\u4FEE\u9A13\u9053\u306E\u958B\u7956\u30FB\u5F79\u884C\u8005\u304C\u62D3\u3044\u305F1,300\u5E74\u306E\u884C\u8005\u9053\u3002\u4E16\u754C\u907A\u7523\u306E\u970A\u5CF0\u3092\u7E4B\u3050\u3001\u65E5\u672C\u6700\u53E4\u306E\u30ED\u30F3\u30B0\u30C8\u30EC\u30A4\u30EB\u3002',
      profile: 'M0,25 10,8 20,20 30,5 40,18 50,8 60,22 70,5 80,15 90,8 100,20 110,5 120,18 140,8 160,15 180,10 200,25'
    },
    {
      name: '\u718A\u91CE\u53E4\u9053 \u5C0F\u8FBA\u8DEF',
      url: 'https://www.tb-kumano.jp/kumano-kodo/kohechi/',
      country: 'Japan',
      region: 'japan',
      distance: '72 km',
      distanceNum: 72,
      days: '3\u301C4\u65E5',
      daysNum: 4,
      elevation: '4,800 m+',
      desc: '\u9AD8\u91CE\u5C71\u304B\u3089\u718A\u91CE\u672C\u5BAE\u5927\u793E\u3078\u306E\u6700\u77ED\u8DEF\u306B\u3057\u3066\u6700\u96E3\u95A2\u30021,000m\u7D1A\u306E\u5CE0\u30923\u3064\u8D8A\u3048\u308B\u3001\u4FEE\u884C\u8005\u306E\u9053\u3002\u4E2D\u8FBA\u8DEF\u3068\u306F\u307E\u305F\u9055\u3046\u967A\u3057\u3055\u3002',
      profile: 'M0,10 10,28 20,8 30,30 40,10 50,32 60,8 70,10 80,28 90,8 100,10 110,28 120,10 140,8 160,25 180,10 200,20'
    },
    {
      name: '\u5C71\u9670\u6D77\u5CB8\u30B8\u30AA\u30D1\u30FC\u30AF\u30C8\u30EC\u30A4\u30EB',
      url: 'https://sanin-geo.jp/geotrail/',
      country: 'Japan',
      region: 'japan',
      distance: '230 km',
      distanceNum: 230,
      days: '10\u301C14\u65E5',
      daysNum: 12,
      elevation: '8,000 m+',
      desc: '\u4EAC\u90FD\u30FB\u5175\u5EAB\u30FB\u9CE5\u53D6\u306E\u65E5\u672C\u6D77\u6CBF\u5CB8\u3092\u6B69\u304F\u3002\u65AD\u5D16\u3001\u7802\u4E18\u3001\u6F01\u6751\u304C\u9023\u306A\u308B\u30B8\u30AA\u30D1\u30FC\u30AF\u306E\u5730\u5F62\u3092\u3001\u6D77\u98A8\u3092\u53D7\u3051\u306A\u304C\u3089\u8E0F\u7834\u3059\u308B\u3002',
      profile: 'M0,25 10,12 20,28 30,15 40,8 50,22 60,10 70,25 80,12 90,20 100,8 110,22 120,15 140,10 160,22 180,14 200,25'
    },
    {
      name: '\u5E83\u5CF6\u6E7E\u5CB8\u30C8\u30EC\u30A4\u30EB',
      url: 'https://hiroshima-wangantrail.jp/',
      country: 'Japan',
      region: 'japan',
      distance: '294 km',
      distanceNum: 294,
      days: '12\u301C18\u65E5',
      daysNum: 15,
      elevation: '12,000 m+',
      desc: '\u5E83\u5CF6\u5E02\u8857\u3092\u53D6\u308A\u56F2\u3080\u5C71\u3005\u3068\u5CF6\u3005\u3092\u7E4B\u3050\u90FD\u5E02\u8FD1\u63A5\u578B\u30C8\u30EC\u30A4\u30EB\u300247\u5C7160\u5CF014\u5CE0\u3001\u702C\u6238\u5185\u6D77\u306E\u591A\u5CF6\u7F8E\u3092\u671B\u307F\u306A\u304C\u3089\u306E\u7A1C\u7DDA\u6B69\u304D\u3002',
      profile: 'M0,22 10,10 20,18 30,8 40,15 50,10 60,20 70,8 80,14 90,10 100,18 110,8 120,15 140,10 160,18 180,12 200,22'
    },
    {
      name: '\u77F3\u939A\u5C71\u7CFB\u7E26\u8D70\u8DEF',
      url: 'https://ishizuchisankei.com/',
      country: 'Japan',
      region: 'japan',
      distance: '80 km',
      distanceNum: 80,
      days: '3\u301C4\u65E5',
      daysNum: 4,
      elevation: '4,500 m+',
      desc: '\u897F\u65E5\u672C\u6700\u9AD8\u5CF0\u30FB\u77F3\u939A\u5C71\u3092\u4E2D\u5FC3\u3068\u3057\u305F\u7E26\u8D70\u8DEF\u3002\u9396\u5834\u3068\u6025\u5CFB\u306A\u5CA9\u7A1C\u3001\u305D\u3057\u3066\u30D6\u30CA\u306E\u539F\u751F\u6797\u3002\u56DB\u56FD\u306E\u5C71\u306E\u6DF1\u3055\u3092\u51DD\u7E2E\u3057\u305F\u7A1C\u7DDA\u3002',
      profile: 'M0,30 10,18 20,8 30,15 40,3 50,10 60,5 70,3 80,8 90,5 100,10 110,15 120,22 140,15 160,10 180,20 200,30'
    },
    {
      name: '\u5944\u7F8E\u30C8\u30EC\u30A4\u30EB',
      url: 'https://www.pref.kagoshima.jp/ad04/kurashi-kankyo/kankyo/amami/amami-trail.html',
      country: 'Japan',
      region: 'japan',
      distance: '550 km',
      distanceNum: 550,
      days: '1\u301C2\u30F6\u6708',
      daysNum: 60,
      elevation: '12,000 m+',
      desc: '\u4E16\u754C\u81EA\u7136\u907A\u7523\u30FB\u5944\u7F8E\u7FA4\u5CF6\u306E8\u3064\u306E\u6709\u4EBA\u5CF6\u3092\u7E4B\u3050\u30C8\u30EC\u30A4\u30EB\u3002\u4E9C\u71B1\u5E2F\u306E\u68EE\u3001\u30B5\u30F3\u30B4\u306E\u6D77\u5CB8\u3001\u5CF6\u3054\u3068\u306B\u7570\u306A\u308B\u6587\u5316\u3068\u81EA\u7136\u3092\u6B69\u304F\u3002',
      profile: 'M0,28 10,18 20,25 30,15 40,22 50,30 60,18 70,25 80,20 90,28 100,15 110,22 120,30 140,18 160,25 180,20 200,28'
    },
    {
      name: 'Colorado Trail',
      url: 'https://coloradotrail.org',
      country: 'USA',
      region: 'usa',
      distance: '782 km',
      distanceNum: 782,
      days: '4\u301C6 \u9031\u9593',
      daysNum: 35,
      elevation: '27,100 m+',
      desc: '\u30ED\u30C3\u30AD\u30FC\u5C71\u8108\u3092\u7AEF\u304B\u3089\u7AEF\u307E\u3067\u3002\u6A19\u9AD83,000m\u8D85\u306E\u7A1C\u7DDA\u6B69\u304D\u304C\u7D9A\u304D\u3001UL\u88C5\u5099\u306E\u8EFD\u3055\u304C\u9AD8\u6240\u3067\u306E\u75B2\u52B4\u3092\u5927\u304D\u304F\u5DE6\u53F3\u3059\u308B\u3002',
      profile: 'M0,20 10,12 20,8 30,15 40,6 50,10 60,5 70,12 80,8 90,14 100,6 110,10 120,8 130,14 140,10 150,18 160,12 170,8 180,15 190,10 200,18'
    },
    {
      name: 'Arizona Trail',
      url: 'https://aztrail.org',
      country: 'USA',
      region: 'usa',
      distance: '1,300 km',
      distanceNum: 1300,
      days: '6\u301C8 \u9031\u9593',
      daysNum: 49,
      elevation: '34,400 m+',
      desc: '\u30BD\u30CE\u30E9\u7802\u6F20\u304B\u3089\u30DD\u30F3\u30C7\u30ED\u30FC\u30B5\u306E\u68EE\u3001\u30B0\u30E9\u30F3\u30C9\u30AD\u30E3\u30CB\u30AA\u30F3\u306E\u7E01\u307E\u3067\u3002\u6C34\u5834\u306E\u8A08\u753B\u304C\u751F\u547D\u7DDA\u306B\u306A\u308B\u7802\u6F20\u30C8\u30EC\u30A4\u30EB\u3002',
      profile: 'M0,30 10,22 20,28 30,18 40,25 50,15 60,20 70,10 80,18 90,25 100,12 110,20 120,28 130,15 140,22 150,30 160,18 170,25 180,20 190,28 200,22'
    },
    {
      name: 'Pacific Northwest Trail',
      url: 'https://www.pnt.org',
      country: 'USA',
      region: 'usa',
      distance: '1,900 km',
      distanceNum: 1900,
      days: '60\u301C75 \u65E5',
      daysNum: 68,
      elevation: '64,000 m+',
      desc: '\u5C71\u8108\u3092\u300C\u6A2A\u65AD\u300D\u3059\u308B\u7570\u8272\u306E\u30EB\u30FC\u30C8\u3002\u30ED\u30C3\u30AD\u30FC\u3001\u30BB\u30EB\u30AB\u30FC\u30AF\u3001\u30AB\u30B9\u30B1\u30FC\u30C9\u3001\u30AA\u30EA\u30F3\u30D4\u30C3\u30AF\u3068\u3001\u5C71\u8108\u306E\u30B0\u30EC\u30A4\u30F3\u306B\u9006\u3089\u3063\u3066\u9032\u3080\u3002',
      profile: 'M0,25 10,15 20,30 30,10 40,25 50,8 60,20 70,12 80,28 90,15 100,22 110,8 120,18 130,28 140,12 150,20 160,30 170,10 180,22 190,15 200,25'
    },
    {
      name: 'Long Trail',
      url: 'https://www.greenmountainclub.org',
      country: 'USA',
      region: 'usa',
      distance: '440 km',
      distanceNum: 440,
      days: '20\u301C30 \u65E5',
      daysNum: 25,
      elevation: '19,400 m+',
      desc: '\u30A2\u30E1\u30EA\u30AB\u6700\u53E4\u306E\u30ED\u30F3\u30B0\u30C8\u30EC\u30A4\u30EB\u3002AT\u306E\u539F\u578B\u306B\u306A\u3063\u305F\u6B74\u53F2\u3042\u308B\u9053\u3002\u30CB\u30E5\u30FC\u30A4\u30F3\u30B0\u30E9\u30F3\u30C9\u306E\u6CE5\u3068\u6839\u3068\u5CA9\u306E\u6D17\u793C\u3092\u53D7\u3051\u308B\u3002',
      profile: 'M0,22 10,15 20,25 30,12 40,20 50,28 60,15 70,22 80,10 90,18 100,25 110,14 120,20 130,28 140,12 150,22 160,18 170,25 180,15 190,20 200,22'
    },
    {
      name: 'Tahoe Rim Trail',
      url: 'https://tahoerimtrail.org',
      country: 'USA',
      region: 'usa',
      distance: '270 km',
      distanceNum: 270,
      days: '10\u301C15 \u65E5',
      daysNum: 13,
      elevation: '10,200 m+',
      desc: '\u30EC\u30A4\u30AF\u30BF\u30DB\u3092\u4E00\u5468\u3059\u308B\u30EB\u30FC\u30D7\u30C8\u30EC\u30A4\u30EB\u3002PCT\u3068\u7D0480km\u91CD\u8907\u3002\u521D\u3081\u3066\u306E\u30ED\u30F3\u30B0\u30CF\u30A4\u30AF\u306B\u3082\u9069\u3057\u305F\u8DDD\u96E2\u611F\u3068\u6574\u5099\u5EA6\u3002',
      profile: 'M0,20 10,14 20,22 30,12 40,18 50,10 60,16 70,22 80,14 90,20 100,12 110,18 120,24 130,14 140,20 150,16 160,22 170,14 180,18 190,12 200,20'
    },
    {
      name: 'Wonderland Trail',
      url: 'https://www.nps.gov/mora/planyourvisit/the-wonderland-trail.htm',
      country: 'USA',
      region: 'usa',
      distance: '150 km',
      distanceNum: 150,
      days: '7\u301C14 \u65E5',
      daysNum: 11,
      elevation: '6,700 m+',
      desc: '\u30EC\u30FC\u30CB\u30A2\u5C71\u3092\u4E00\u5468\u30021\u65E5\u3042\u305F\u308A1,000m\u4EE5\u4E0A\u306E\u4E0A\u4E0B\u52D5\u304C\u5F53\u305F\u308A\u524D\u306E\u30BF\u30D5\u306A\u30EB\u30FC\u30C8\u3002Permit\u7AF6\u4E89\u304C\u5E74\u3005\u6FC0\u5316\u3057\u3066\u3044\u308B\u3002',
      profile: 'M0,20 10,35 20,10 30,32 40,8 50,30 60,12 70,35 80,10 90,28 100,15 110,32 120,8 130,30 140,12 150,35 160,10 170,28 180,15 190,32 200,20'
    },
    {
      name: 'High Sierra Trail',
      url: 'https://www.nps.gov/seki/planyourvisit/high-sierra-trail.htm',
      country: 'USA',
      region: 'usa',
      distance: '116 km',
      distanceNum: 116,
      days: '5\u301C9 \u65E5',
      daysNum: 7,
      elevation: '4,600 m+',
      desc: '\u30BB\u30B3\u30A4\u30A2\u306E\u5DE8\u6728\u304B\u3089Mt.\u30DB\u30A4\u30C3\u30C8\u30CB\u30FC\u5C71\u9802\u3078\u3001\u30B7\u30A8\u30E9\u30CD\u30D0\u30C0\u3092\u6771\u897F\u306B\u6A2A\u65AD\u3002\u77ED\u3044\u304C\u51DD\u7E2E\u3055\u308C\u305F\u9AD8\u5C71\u4F53\u9A13\u3002',
      profile: 'M0,30 10,25 20,18 30,22 40,12 50,15 60,8 70,10 80,5 90,8 100,4 110,6 120,3 140,5 160,8 180,4 200,2'
    },
    {
      name: 'Hayduke Trail',
      url: 'https://www.hayduketrail.org',
      country: 'USA',
      region: 'usa',
      distance: '1,300 km',
      distanceNum: 1300,
      days: '40\u301C60 \u65E5',
      daysNum: 50,
      elevation: '34,100 m+',
      desc: '\u975E\u516C\u5F0F\u3001\u672A\u6574\u5099\u3001\u30EB\u30FC\u30C8\u30D5\u30A1\u30A4\u30F3\u30C7\u30A3\u30F3\u30B0\u306E\u9023\u7D9A\u30026\u3064\u306E\u56FD\u7ACB\u516C\u5712\u3092\u7E4B\u3050\u5192\u967A\u30EB\u30FC\u30C8\u3002\u30C8\u30EC\u30A4\u30EB\u3092\u6B69\u304F\u306E\u3067\u306F\u306A\u304F\u3001\u5730\u5F62\u3092\u8AAD\u3080\u3002',
      profile: 'M0,22 10,30 20,15 30,28 40,20 50,32 60,18 70,25 80,30 90,15 100,28 110,20 120,25 130,32 140,18 150,28 160,22 170,30 180,15 190,25 200,22'
    }
  ];

  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
    return arr;
  }

  function cardHTML(t) {
    return '<li class="miy-trails__card" data-region="' + t.region + '" data-country="' + t.country + '" data-distance="' + t.distanceNum + '" data-days="' + t.daysNum + '" data-name="' + t.name + '">'
      + '<div class="miy-trails__card-header">'
      + '  <h3 class="miy-trails__card-name">' + (t.url ? '<a href="' + t.url + '" target="_blank" rel="noopener noreferrer">' + t.name + '</a>' : t.name) + '</h3>'
      + '  <span class="miy-trails__card-country">' + t.country + '</span>'
      + '</div>'
      + '<p class="miy-trails__card-desc">' + t.desc + '</p>'
      + '<div class="miy-trails__stats">'
      + '  <div class="miy-trails__stat"><span class="miy-trails__stat-label">Distance</span><span class="miy-trails__stat-value">' + t.distance + '</span></div>'
      + '  <div class="miy-trails__stat"><span class="miy-trails__stat-label">Days</span><span class="miy-trails__stat-value">' + t.days + '</span></div>'
      + '  <div class="miy-trails__stat"><span class="miy-trails__stat-label">Elevation</span><span class="miy-trails__stat-value">' + t.elevation + '</span></div>'
      + '</div>'
      + '<svg class="miy-trails__elevation" viewBox="0 0 200 40" preserveAspectRatio="none"><path d="' + t.profile + ' L200,40 0,40Z" fill="rgba(255,255,255,.3)" /><path d="' + t.profile + '" fill="none" stroke="rgba(255,255,255,.5)" stroke-width="1.5" /></svg>'
      + '</li>';
  }

  function renderTrails(gridId) {
    var grid = document.getElementById(gridId);
    if (!grid) return;
    var picked = shuffle(trails.slice()).slice(0, 3);
    grid.innerHTML = picked.map(cardHTML).join('');
  }

  /**
   * Initialize trail section
   * @param {string} gridId    — id of the <ul> grid element
   * @param {string} buttonId  — id of the reload button
   */
  window.initTrails = function(gridId, buttonId) {
    renderTrails(gridId);
    var btn = document.getElementById(buttonId);
    if (btn) {
      btn.addEventListener('click', function() {
        renderTrails(gridId);
        document.getElementById(gridId).scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  };

  /**
   * Initialize full trails page — region sections with sort & filter
   * @param {string} gridId           — id of the main container element
   * @param {string} filterContainerId — id of the filter button container
   */
  window.initAllTrails = function(gridId, filterContainerId) {
    var container = document.getElementById(gridId);
    if (!container) return;

    var regions = [
      { key: 'japan', label: 'JAPAN', count: 0 },
      { key: 'usa', label: 'USA', count: 0 },
      { key: 'world', label: 'WORLD', count: 0 }
    ];

    trails.forEach(function(t) {
      regions.forEach(function(r) {
        if (t.region === r.key) r.count++;
      });
    });

    var currentSort = 'name';
    var currentRegionFilter = 'all';

    function sortTrails(arr, key) {
      return arr.slice().sort(function(a, b) {
        switch (key) {
          case 'name': return a.name.localeCompare(b.name);
          case 'distance-asc': return a.distanceNum - b.distanceNum;
          case 'distance-desc': return b.distanceNum - a.distanceNum;
          case 'days-asc': return a.daysNum - b.daysNum;
          case 'days-desc': return b.daysNum - a.daysNum;
          default: return a.name.localeCompare(b.name);
        }
      });
    }

    function renderRegions() {
      var html = '';
      regions.forEach(function(r) {
        var regionTrails = trails.filter(function(t) { return t.region === r.key; });

        if (currentRegionFilter !== 'all' && currentRegionFilter !== r.key) return;

        if (regionTrails.length === 0) return;

        var sorted = sortTrails(regionTrails, currentSort);

        html += '<div class="trails__region-section" data-region="' + r.key + '">';
        html += '<div class="trails__region-header">';
        html += '<h2 class="trails__region-title">' + r.label + '</h2>';
        html += '<span class="trails__region-count">' + sorted.length + ' trails</span>';
        html += '</div>';
        html += '<ul class="miy-trails__grid trails__grid">';
        html += sorted.map(cardHTML).join('');
        html += '</ul>';
        html += '</div>';
      });
      container.innerHTML = html;
    }

    // Build sort bar
    var sortBar = document.getElementById('trails-sort');
    if (sortBar) {
      sortBar.innerHTML = '<button class="trails__sort-btn active" data-sort="name">Name</button>'
        + '<button class="trails__sort-btn" data-sort="distance-asc">Distance ↑</button>'
        + '<button class="trails__sort-btn" data-sort="distance-desc">Distance ↓</button>'
        + '<button class="trails__sort-btn" data-sort="days-asc">Days ↑</button>'
        + '<button class="trails__sort-btn" data-sort="days-desc">Days ↓</button>';

      sortBar.addEventListener('click', function(e) {
        var btn = e.target.closest('.trails__sort-btn');
        if (!btn) return;
        sortBar.querySelectorAll('.trails__sort-btn').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        currentSort = btn.getAttribute('data-sort');
        renderRegions();
      });
    }

    // Build region filter buttons
    var filterEl = document.getElementById(filterContainerId);
    if (filterEl) {
      var fhtml = '<button class="miy-trails__filter active" data-region-filter="all">ALL (' + trails.length + ')</button>';
      regions.forEach(function(r) {
        fhtml += '<button class="miy-trails__filter" data-region-filter="' + r.key + '">' + r.label + ' (' + r.count + ')</button>';
      });
      filterEl.innerHTML = fhtml;

      filterEl.addEventListener('click', function(e) {
        var btn = e.target.closest('.miy-trails__filter');
        if (!btn) return;
        filterEl.querySelectorAll('.miy-trails__filter').forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        currentRegionFilter = btn.getAttribute('data-region-filter');
        renderRegions();
      });
    }

    // Initial render
    renderRegions();
  };
})();
